






















import * as _ from 'lodash-es';
import { computed, defineComponent, onMounted, PropType, toRefs, watch } from '@vue/composition-api';
import { useRequest, usePowerInfoApi, useAdgroupIos14 } from '@tt4b/ttam-hooks';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import PowerSvg from './power-svg.vue';
import {
  AdgroupFormData,
  AutoTargetingEnum,
  CampaignFormData,
  SplitTestFormData,
  targetModuleKeys,
} from '@tt4b/ttam-enums';

import { computeValue } from './set-power-animation';

const name = 'ttam-split-budget-power';

export default defineComponent({
  name,
  components: {
    PowerSvg,
    TooltipInfo,
  },
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { adgroupData, campaignData, splitTestFormData } = toRefs(props);

    const { opSysFilter } = useAdgroupIos14({ adgroupFormData: adgroupData, campaignFormData: campaignData });

    const { data: powerInfo, run: getSplitTestPower } = useRequest(
      usePowerInfoApi,
      { budget: 0, formDataArr: [] },
      { manual: true },
    );

    const power = computed(() => powerInfo.value?.power ?? 0);

    const estimateText = computed(() => computeValue(power.value, 'estimateText'));
    const estimateTextColor = computed(() => computeValue(power.value, 'dotColor'));
    const estimateHint = computed(() => computeValue(power.value, 'estimateHint'));

    function getParamBatchFormdata(): Partial<AdgroupFormData & { opSysFilter: number }>[] {
      const param = [_.pick(adgroupData.value, targetModuleKeys)];
      const { inventoryFlow, internetServiceProviders, automatedTargeting } = adgroupData.value;

      return param.map(item => ({
        ...item,
        inventoryFlow,
        internetServiceProviders: Number(automatedTargeting) === AutoTargetingEnum.AUTO ? [] : internetServiceProviders,
        opSysFilter: opSysFilter.value,
      }));
    }

    onMounted(() => {
      watch(
        () => splitTestFormData.value.budget,
        val => {
          const budget = Number(val);
          getSplitTestPower({ budget, formDataArr: getParamBatchFormdata() });
        },
        { immediate: true },
      );
    });

    return {
      name,
      power,
      estimateText,
      estimateTextColor,
      estimateHint,
    };
  },
});
